module.exports = __webpack_public_path__ + "img/perikefalaia.f291dbd0.jpg";